import '../../style/App.css';
import { Popover } from '@base-ui-components/react/popover';

const CloseSvg = ({clickable=false, onClick}) => {
    return (
        <div style={{cursor: clickable ? 'pointer' : 'default'}} onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30">
                <g>
                    <line x1="10" y1="5" x2="40" y2="25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="40" y1="5" x2="10" y2="25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                </g>
            </svg>
        </div>
    )
}

const WidgetPopUp = ({trigger, popUp, onOpenChange, popOverClass, popOverClassContainer, alignOffset, sideOffset, triggerClass, openOnHover=false, align='end', side='bottom', disabled=false, modal=false, enableTriggerClass=true, closeButton=false, delay=0}) => {
   const finalTriggerClass = [enableTriggerClass ? 'widgetPopupTrigger' : null, triggerClass].filter(Boolean).join(' ');

   return <Popover.Root onOpenChange={onOpenChange} openOnHover={openOnHover} modal={'trap-focus'} delay={delay}>
                <Popover.Trigger className={finalTriggerClass || undefined} onClick={(event) => event.stopPropagation()} disabled={disabled}>
                    {trigger}
                </Popover.Trigger>
                <Popover.Portal>
                    <Popover.Positioner align={align} side={side} sticky={true} alignOffset={alignOffset} sideOffset={sideOffset}>
                        <Popover.Popup className={`${popOverClassContainer} widgetPopover editHpGrow`}>
                            <Popover.Description className={popOverClass} render={<div/>} onClick={(event) => event.stopPropagation()}>
                                {closeButton && <Popover.Close className={'popOverClose editHpGrow'} >✔️</Popover.Close>}
                                {popUp}
                            </Popover.Description>
                        </Popover.Popup>
                    </Popover.Positioner>
                </Popover.Portal>
            </Popover.Root>;
};

export default WidgetPopUp;